export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";